export type WorkdayValue = 'monday' | 'tuesday' | 'wednesday' | 'thursday' | 'friday' | 'saturday' | 'sunday';

export type ShiftOption = { value: string; label: { en: string; nl: string } };
export type WorkdayOption = { value: WorkdayValue; label: { en: string; nl: string } };

export const shiftOptions: ShiftOption[] = [
  { value: 'shiftDay', label: { en: 'Day shift', nl: 'Dagdienst' } },
  { value: 'shiftEvening', label: { en: 'Evening shift', nl: 'Avonddienst' } },
  { value: 'shiftNight', label: { en: 'Night shift', nl: 'Nachtdienst' } },
  { value: 'shift2Cycle', label: { en: '2-cycle shift', nl: '2 ploegen dienst' } },
  { value: 'shift3Cycle', label: { en: '3-cycle shift', nl: '3 ploegen dienst' } },
  { value: 'shift4Cycle', label: { en: '4-cycle shift', nl: '4 ploegen dienst' } },
  { value: 'shift5Cycle', label: { en: '5-cycle shift', nl: '5 ploegen dienst' } },
];

export const workdayOptions: WorkdayOption[] = [
  { value: 'monday', label: { en: 'Monday', nl: 'Maandag' } },
  { value: 'tuesday', label: { en: 'Tuesday', nl: 'Dinsdag' } },
  { value: 'wednesday', label: { en: 'Wednesday', nl: 'Woensdag' } },
  { value: 'thursday', label: { en: 'Thursday', nl: 'Donderdag' } },
  { value: 'friday', label: { en: 'Friday', nl: 'Vrijdag' } },
  { value: 'saturday', label: { en: 'Saturday', nl: 'Zaterdag' } },
  { value: 'sunday', label: { en: 'Sunday', nl: 'Zondag' } },
];

export function getShiftLabel(shift: string, language: 'en' | 'nl'): string {
  return shiftOptions.find((o) => o.value === shift)?.label[language] ?? shift;
}

export function getWorkdayLabel(workday: string, language: 'en' | 'nl'): string {
  return workdayOptions.find((o) => o.value === workday)?.label[language] ?? workday;
}
